import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
// import { useTranslation } from 'react-i18next';
import { Tab } from '@components/Tabs/Tab';
import { Tabs } from '@components/Tabs/Tabs';

import { useGetPartnersTaskQuery } from '@/api/queries/user';
import { useCountPartnerTaskDelay } from '@/common/hooks/count-partnerTask-delay';
import { DailyRewardBanner } from '@/components/Task/DailyRewardBanner/DailyRewardBanner';
import PartnersTask from '@/components/Task/PartnersTask/PartnersTask';
// import { TabsNavigation } from '@components/Tabs/TabsNavigation';
// import FriendsBody from '../../components/Task/FriendsBody/FriendsBody';
import SocialNetworkBody from '@/components/Task/SocialNetworkBody/SocialNetworkBody';
import { H1 } from '@/components/Typography/Typography';
import {
  checkLevelToGetRewards,
  getActiveReward,
  getIsBoughtPlan,
  getPaidRewardPlanCost,
} from '@/redux/selectors/earnRewardsSelector';
import { partnersTaskTimerEnd } from '@/redux/selectors/taskSelector';
import { useAppSelector } from '@/redux/store';

const Task: React.FC = () => {
  const { t } = useTranslation();
  const congruentLevel = useAppSelector(checkLevelToGetRewards);
  const activeReward = useAppSelector(getActiveReward);
  const cost = useAppSelector(getPaidRewardPlanCost);
  const isBoughtPlan = useAppSelector(getIsBoughtPlan);
  const partners = useAppSelector((state) => state.tasks.partners);
  const isTimersEnd = useAppSelector(partnersTaskTimerEnd);
  useGetPartnersTaskQuery();
  useCountPartnerTaskDelay(isTimersEnd);
  // const [, setActiveTab] = useState('1');
  // const { t } = useTranslation();

  // const tabList = [
  //   {
  //     id: '1',
  //     label: t('Socials'),
  //   },
  //   {
  //     id: '2',
  //     label: t('Friends'),
  //   },
  // ];

  return (
    <main className="page">
      <Helmet>
        <title>Earn</title>
      </Helmet>
      <div className="task-page">
        <div className="tabs container !px-2">
          <div
            style={{
              backgroundImage: 'url(img/Bg-telegram.png)',
              height: '13.75rem',
              overflow: 'hidden',
              position: 'relative',
              backgroundPosition: 'center bottom',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              width: '100%',
              marginLeft: '-8px',
            }}
          >
            <img
              src="img/Telegram.png"
              alt=""
              width={113}
              height={94}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          </div>
          {congruentLevel && (activeReward || (!!cost && !isBoughtPlan)) && (
            <DailyRewardBanner />
          )}
          {/* <SpendStarsBanner /> */}
          <Tabs initActiveTab="1">
            {/* <TabsNavigation onTabChange={setActiveTab} list={tabList} /> */}
            <Tab tabId="1" className="mt-4">
              <H1>{t('Social Tasks')}</H1>
              <SocialNetworkBody />
            </Tab>
            {!!partners?.length && (
              <Tab tabId="1" className="mt-4">
                <H1>{t('Partners Tasks')}</H1>
                <PartnersTask partners={partners} />
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
    </main>
  );
};

export default Task;
